import React from 'react';

import type {ICommoditySelectionSubStepProps} from '../productionInfo.types';

export const CommoditySelectionSubStep: React.FC<
  ICommoditySelectionSubStepProps
> = ({
  commodityError,
  isLoadingCommodities,
  commodityTypes,
  selectedCommoditySet,
  isSavingCommodities,
  onToggleCommodity,
}) => (
  <div className="application-card">
    <div className="commodity-selector">
      <header className="commodity-selector__header">
        <h3>Commodities for funding</h3>
        <p>Select all commodities included in this funding application.</p>
      </header>

      {commodityError ? (
        <div className="form-alert is-error">{commodityError}</div>
      ) : null}

      {isLoadingCommodities ? (
        <div className="application-empty-state">
          <h3>Loading commodities</h3>
        </div>
      ) : (
        <div className="commodity-selector__grid">
          {commodityTypes.map((commodity) => {
            const commodityId = Number(commodity.id);
            const isSelected = selectedCommoditySet.has(commodityId);

            return (
              <button
                key={commodity.id}
                type="button"
                className={`commodity-selector__item${
                  isSelected ? ' is-selected' : ''
                }`}
                onClick={() => onToggleCommodity(commodityId)}
                aria-pressed={isSelected}
                disabled={isSavingCommodities}
              >
                <span>{commodity.name}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  </div>
);
